<label >
  <input
    type="file"
    class="hidden"
    (change)="handleFileInput($event.target.files)"
    [accept]="acceptFiles"
  />
  <div
    class="flex flex-col items-center justify-center rounded-lg cursor-pointer border-2 border-gray-300 border-dashed hover:bg-hover transition-colors duration-150 ease-in-out"
    [class]="sizeClass"
  >
  <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
    <span>{{ label }}</span>
  </div>
</label>
